import React from "react";
import { useMediaQuery } from "react-responsive";
import OfferLoader from "../../../../loader/OfferLoader";
import MatchedItemDetail from "../../../../sellerAuction/dashboard/singleOffer/children/MatchedItemDetail ";

function ProductScrapDetails({ singleOfferData, loadings }) {
  const isDestop = useMediaQuery({ query: "(max-width: 1300px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 900px)" });
  const isMoblie = useMediaQuery({ query: "(max-width: 500px)" });

  return (
    <div>
      {loadings ? (
        <OfferLoader label={true} />
      ) : (
        <div
          key={singleOfferData?._id}
          className={`cover white mb-2 pin-top gap-1 textAlign-center
              `}
          style={{
            display: "grid",
            gridTemplateColumns: isMoblie
              ? "repeat(1,1fr)"
              : isDestop
              ? "repeat(3,1fr)"
              : "repeat(6,1fr)",
            padding: isTablet ? "3rem 1rem 2rem 2rem" : "2rem",
          }}
        >
          <MatchedItemDetail
            label="Scrap Type"
            value={singleOfferData?.scrapDetails?.type}
          />
          <MatchedItemDetail
            label="Quantity / UOM"
            value={`${singleOfferData?.scrapDetails?.quantity}/${singleOfferData?.scrapDetails?.unit}`}
          />
          <MatchedItemDetail
            label="EMD Amount (Rs.)"
            value={singleOfferData?.EMDAmount}
          />
          <MatchedItemDetail
            label="Starting price (Rs.)"
            value={
              singleOfferData?.startingPrice > 0
                ? singleOfferData?.startingPrice
                : "N/A"
            }
          />
          <MatchedItemDetail
            label="Lifting Period"
            value={singleOfferData?.liftingPeriod}
          />

          <MatchedItemDetail
            label="max Decrement (Rs.)"
            value={singleOfferData?.minimumBidDecrease}
          />

          <p
            className="button-style white-text font-18px select-label"
            style={{
              padding: "8px 20px",
              top: "-20px",
              left: "2%",
              backgroundImage: "linear-gradient(#6F2DA8, #3B0966)",
            }}
          >
            {`Lot Id : ${singleOfferData?.offerNumber}`}
          </p>
        </div>
      )}
    </div>
  );
}

export default ProductScrapDetails;
